import { PatientQueue, PatientQueueEntry } from '@/core/models/patient-queue.model'

export function isPatientInQueue(patientId: string, queueData: PatientQueue) {
  if (!queueData?.queue) return false
  return queueData.queue.some((entry: PatientQueueEntry) => {
    const queuePatientId = typeof entry.patient === 'string' ? entry.patient : entry.patient?._id
    return queuePatientId === patientId
  })
}
